import HelpRoutes from './help-routes';

import './help.scss';

const MODULE_NAME = 'App.help';
const module = angular
    .module(MODULE_NAME, [])
    .config(HelpRoutes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/help/help-module.js